/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Reactivate_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Members regain access. Sync resumes on the next user-triggered or webhook event." |
*
* @param {Spaces_Reactivate_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_reactivate_confirm_description = /** @type {((inputs?: Spaces_Reactivate_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Reactivate_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder erhalten wieder Zugriff. Sync wird beim nächsten Trigger fortgesetzt.")
	return /** @type {LocalizedString} */ ("Members regain access. Sync resumes on the next user-triggered or webhook event.")
});